"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchClientContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var PerformerFallback = __importStar(require("icf-search-client-data/lib/PerformerFallback"));
var PublisherService = __importStar(require("icf-search-client-shared/lib/services/EventPublisher"));
var LoggerService = __importStar(require("icf-search-client-shared/lib/services/LoggerService"));
var StatsdService = __importStar(require("icf-search-client-shared/lib/services/StatsDClient"));
var queryStringParser = __importStar(require("querystring"));
var React = __importStar(require("react"));
var ThemeProvider_1 = __importDefault(require("@atg/icf-react-components/components/ThemeProvider"));
var DataUrlCache_1 = require("icf-search-client-data/lib/cache/DataUrlCache");
var RemoteAssetLoader_1 = require("icf-search-client-data/lib/RemoteAssetLoader");
var AutocompleteService_1 = require("icf-search-client-data/lib/services/AutocompleteService");
var SearchApiClientFactory_1 = require("icf-search-client-data/lib/services/SearchApiClientFactory");
var UserService_1 = require("icf-search-client-data/lib/services/UserService");
var RecommenderExperiment_1 = require("icf-search-client-shared/lib/services/RecommenderExperiment");
var RecommenderSession_1 = require("icf-search-client-shared/lib/services/RecommenderSession");
var SkinConfigService_1 = require("icf-search-client-shared/lib/services/SkinConfigService");
var StatsDClient_1 = require("icf-search-client-shared/lib/services/StatsDClient");
var XmentService_1 = require("icf-search-client-shared/lib/services/XmentService");
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var StreamPlayerFactory_1 = require("../services/StreamPlayerFactory");
var Contexts_1 = require("./Contexts");
var Ioc_1 = require("./utilities/Ioc");
// prettier-ignore
var europeanCountrySet = new Set([
    "DE", "FR", "IE", "GB", "AD", "MC", "LU", "NL", "AT", "CH", "LI", "BE", "LV", "NO", "LT", "IM", "GG", "SE", "FI", "JE", "SJ", "DK", "AX", "EE", "IS", "FO", "ES", "CY", "TR", "GR", "SM", "GI", "VA",
    "IT", "MT", "PT", "MK", "AL", "UA", "AZ", "RO", "ME", "RU", "BA", "BG", "MD", "HR", "SI", "AM", "SK", "YU", "GE", "BY", "HU", "XK", "CZ", "PL", "RS",
]);
var remoteAssetLoader = new RemoteAssetLoader_1.CachedRemoteAssetLoader(DataUrlCache_1.DataUrlCache.instance);
var SearchClientContext = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (!LoggerService.wrappedLogger) {
        // @ts-ignore
        LoggerService.wrappedLogger = props.logger;
    }
    if (!StatsdService.wrapperStatsdClient && ((_a = props.tracking) === null || _a === void 0 ? void 0 : _a.statsdClient)) {
        // @ts-ignore
        StatsdService.wrapperStatsdClient = (_b = props.tracking) === null || _b === void 0 ? void 0 : _b.statsdClient;
    }
    if (!PublisherService.wrappedEventPublisher && ((_c = props.tracking) === null || _c === void 0 ? void 0 : _c.eventPublisher)) {
        // @ts-ignore
        PublisherService.wrappedEventPublisher = props.tracking.eventPublisher;
    }
    var translation = React.useMemo(function () { var _a, _b; return ({ translate: (_b = (_a = props.translation) === null || _a === void 0 ? void 0 : _a.translateFunc) !== null && _b !== void 0 ? _b : (function (s) { return s; }) }); }, [props.translation]);
    var searchSkinConfig = React.useMemo(function () { return (0, SkinConfigService_1.filterSearchSkinConfig)(props.skinConfig); }, [props.skinConfig]);
    var playerFactory = React.useMemo(function () { return new StreamPlayerFactory_1.StreamPlayerFactory(props.user, props.streaming); }, [props.user, props.streaming]);
    var xmentService = React.useMemo(function () { return new XmentService_1.XmentService(props.xment); }, [props.xment]);
    var tracking = React.useMemo(function () { return props.tracking; }, [(_d = props.tracking) === null || _d === void 0 ? void 0 : _d.eventPublisher, (_e = props.tracking) === null || _e === void 0 ? void 0 : _e.statsdClient]);
    var statsDClient = React.useMemo(function () {
        var _a;
        return (_a = ((tracking === null || tracking === void 0 ? void 0 : tracking.statsdClient) && {
            count: function (key) { return tracking.statsdClient.count(StatsDClient_1.statsdPrefix + key); },
            timing: function (key, timing) { return tracking.statsdClient.timing(StatsDClient_1.statsdPrefix + key, timing); },
        })) !== null && _a !== void 0 ? _a : undefined;
    }, [tracking === null || tracking === void 0 ? void 0 : tracking.statsdClient]);
    var api = React.useMemo(function () {
        return props.api;
    }, [props.api.baseUrl, props.api.endpoints, props.api.headers]);
    var user = React.useMemo(function () {
        var _a, _b;
        var urlQueryParams = ((_b = (_a = props.router) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.search)
            ? queryStringParser.parse(props.router.location.search.substring(1))
            : null;
        var countryOverride = urlQueryParams === null || urlQueryParams === void 0 ? void 0 : urlQueryParams.countryOverride;
        var experimentNameOverride = urlQueryParams === null || urlQueryParams === void 0 ? void 0 : urlQueryParams.experimentNameOverride;
        var usercopy = props.user;
        if (typeof countryOverride === "string" && countryOverride.match(/^[a-zA-Z]{2}$/)) {
            usercopy.country = countryOverride.toUpperCase();
            if (europeanCountrySet.has(usercopy.country)) {
                usercopy.isEuropeanCountry = true;
            }
        }
        var session = {
            isBlurred: (0, UserService_1.isThumbnailBlurred)(props.user),
            isLoggedIn: usercopy.isAuthenticated,
            continent: usercopy.isEuropeanCountry ? "europe" : "not-europe lol",
            country: usercopy.country,
        };
        PerformerFallback.initialize({ domain: props.skinConfig.global.domain });
        if (typeof experimentNameOverride === "string" && experimentNameOverride.match(/^[a-zA-Z0-9-]*$/)) {
            session.experimentName = RecommenderExperiment_1.EXPERIMENTNAME_OVERRIDE_PREFIX + experimentNameOverride;
        }
        (0, RecommenderSession_1.updateRecommenderSession)(session);
        return usercopy;
    }, [
        props.user.isAuthenticated,
        props.user.id,
        props.user.sakey,
        props.user.ageVerificationRules,
        props.user.isFreemium,
        props.user.isEuropeanCountry,
        props.user.country,
    ]);
    var searchApiClientFactory = React.useMemo(function () { return new SearchApiClientFactory_1.SearchApiClientFactory(user, props, searchSkinConfig, xmentService); }, [api, searchSkinConfig, xmentService, user]);
    var autocompleteService = React.useMemo(function () {
        return new AutocompleteService_1.AutocompleteService(searchApiClientFactory);
    }, [searchApiClientFactory]);
    var theme = React.useMemo(function () {
        return props.theme;
    }, [props.theme.mode, props.theme.colors]);
    var layout = React.useMemo(function () {
        return props.layout;
    }, [props.layout.breakpoint]);
    var favorites = React.useMemo(function () {
        return props.favorites;
    }, [props.favorites]);
    var imageBucket = React.useMemo(function () {
        return props.imageBucket;
    }, [(_f = props.imageBucket) === null || _f === void 0 ? void 0 : _f.biopicUrl, (_g = props.imageBucket) === null || _g === void 0 ? void 0 : _g.snapshotUrl]);
    var router = React.useMemo(function () {
        return props.router;
    }, [props.router]);
    return ((0, jsx_runtime_1.jsx)(ThemeProvider_1.default, { themeMode: theme.mode, primaryColor: theme.colors.primary, direction: theme.direction, "data-fedmod": "search", children: (0, jsx_runtime_1.jsx)(Ioc_1.ContextProvider, { contexts: [
                [Contexts_1.IDataUrlCacheContext, DataUrlCache_1.DataUrlCache.instance],
                [Contexts_1.ILoggerContext, props.logger],
                [Contexts_1.IRemoteAssetLoaderContext, remoteAssetLoader],
                [Contexts_1.ITranslationServiceContext, translation],
                [Contexts_1.IThemeContext, theme],
                [Contexts_1.ISearchSkinConfigContext, searchSkinConfig],
                [Contexts_1.IUserContext, user],
                [Contexts_1.IStreamPlayerFactoryContext, playerFactory],
                [Contexts_1.ILayoutContext, layout],
                [Contexts_1.ILinkComponentContext, (_h = props.linkComponent) !== null && _h !== void 0 ? _h : react_router_dom_1.Link],
                [Contexts_1.IXmentServiceContext, xmentService],
                [Contexts_1.IEventPublisherContext, tracking === null || tracking === void 0 ? void 0 : tracking.eventPublisher],
                [Contexts_1.IStatsdClientContext, statsDClient],
                [Contexts_1.IFavoritePerformersServiceContext, favorites],
                [Contexts_1.IAutocompleteServiceContext, autocompleteService],
                [Contexts_1.IImageBucketContext, imageBucket],
                [Contexts_1.ISearchApiClientFactoryContext, searchApiClientFactory],
                [Contexts_1.IRouterContext, router],
            ], children: (0, jsx_runtime_1.jsx)(react_router_1.__RouterContext.Provider, { value: props.router, children: props.children }) }) }));
};
exports.SearchClientContext = SearchClientContext;
exports.SearchClientContext.displayName = "SearchClientContext";
//# sourceMappingURL=SearchClientContext.js.map